import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable, from } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  EMPLOYEE_PETTY_CASH_STATUS,
  FIND_ACCOUNTS_BY_TYPES,
  GET_PETTY_CASH_ACTIVITY,
  LIST_PETTY_CASH,
  LIST_PETTY_CASH_ACTIVITIES,
  PETTY_CASH_ACCOUNTS,
} from '../graphql/queries/petty-cash.query';
import {
  APPROVE_OR_REJECT_PETTY_CASH_ACTIVITY,
  CREATE_PETTY_CASH_ACCOUNT,
  CREATE_PETTY_CASH_ACTIVITY,
  REMOVE_PETTY_CASH,
  UPDATE_PETTY_CASH,
  UPDATE_PETTY_CASH_ACTIVITY,
} from '../graphql/mutation/petty-cash.mutation';

@Injectable({
  providedIn: 'root',
})
export class PettyCashService {
  constructor(private apollo: Apollo) {}

  fetchPettyCash(search: any): Observable<any> {
    return this.apollo
      .use('accounts')
      .query<any>({
        query: LIST_PETTY_CASH,
        variables: {
          search,
        },
        fetchPolicy: 'network-only',
      })
      .pipe(map((result) => result.data?.pettyCashes || []));
  }

  fetchPettyCashActivities(pettyCashId: any): Observable<any> {
    return this.apollo
      .use('accounts')
      .watchQuery<any>({
        query: LIST_PETTY_CASH_ACTIVITIES,
        variables: {
          pettyCashId,
        },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(
        map((result) => result.data?.pettyCashActivities || [])
      );
  }


  createPettyCashAccount(pettyCashInput: any, activityInput: any): Observable<any> {
    return this.apollo.use('accounts').mutate({
      mutation: CREATE_PETTY_CASH_ACCOUNT,
      variables: {
        pettyCashInput,
        activityInput,
      },
    });
  }

  updatePettyCash(updatePettyCashInput: any): Observable<any> {
    return this.apollo.use('accounts').mutate({
      mutation: UPDATE_PETTY_CASH,
      variables: {
        updatePettyCashInput,
      },
    });
  }

  removePettyCash(id: any): Observable<any> {
    return this.apollo.use('accounts').mutate({
      mutation: REMOVE_PETTY_CASH,
      variables: {
        id,
      },
    });
  }

  fetchPettyCashAccounts(search: any, isActive: any): Observable<any> {
    return this.apollo
      .use('accounts')
      .query<any>({
        query: PETTY_CASH_ACCOUNTS,
        variables: {
          search,
          isActive,
        },
        fetchPolicy: 'network-only',
      })
      .pipe(map((result) => result.data?.pettyCashAccounts || []));
  }

  findAccountsByMultipleTypes(accountTypes: any, search: any): Observable<any> {
    return this.apollo
      .use('accounts')
      .query<any>({
        query: FIND_ACCOUNTS_BY_TYPES,
        variables: {
          accountTypes: accountTypes,
          search: search,
        },
        fetchPolicy: 'network-only',
      })
      .pipe(map((response) => response.data?.findAccountsByMultipleTypes));
  }

  createPettyCashActivity(activityInput: any): Observable<any> {
    return this.apollo.use('accounts').mutate({
      mutation: CREATE_PETTY_CASH_ACTIVITY,
      variables: {
        activityInput,
      },
    });
  }

  approveOrRejectPettyCashActivity(
    activityId: any,
    isApproved: Boolean
  ): Observable<any> {
    return this.apollo.use('accounts').mutate({
      mutation: APPROVE_OR_REJECT_PETTY_CASH_ACTIVITY,
      variables: {
        activityId,
        isApproved,
      },
    });
  }


  fetchPettyCashActivityById(id: any): Observable<any> {
    return this.apollo
      .use('accounts')
      .watchQuery<any>({
        query: GET_PETTY_CASH_ACTIVITY,
        variables: {
          id,
        },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(
        map((result) => result.data?.pettyCashActivity || [])
      );
  }

  updatePettyCashActivity(updatePettyCashActivityInput: any, id: any): Observable<any> {
    return this.apollo.use('accounts').mutate({
      mutation: UPDATE_PETTY_CASH_ACTIVITY,
      variables: {
        updatePettyCashActivityInput,
        id
      },
    });
  }

  employeeHasPettyCash(employeeId: any): Observable<{ exists: boolean; currentBalance: string }> {
    return this.apollo
      .use('accounts')
      .watchQuery<any>({
        query: EMPLOYEE_PETTY_CASH_STATUS,
        variables: { employeeId },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(
        map((result) => result.data?.employeeHasPettyCash)
      );
  }
  



  
}
